<template>
    <div class="ah-page tutorial-page">
        <div class="breadcrumb-row">
            <div class="ah-container ">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'index' }">首頁</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ name: 'tutorial' }">使用教學</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header feature">
                    <div class="panel-title">使用教學</div>
                </div>
                <div class="panel-body">
                    <el-row :gutter="20">
                        <el-col :sm="6">
                            <div class="main-menu">
                                <div class="item">一般請款</div>
                                <div class="item">專案請款</div>
                                <div class="item">特定費用請款</div>
                                <div class="item">經常性費用請款</div>
                                <div class="item">開立發票</div>
                                <div class="item">收支項目設定</div>
                                <div class="item">匯費登錄</div>
                            </div>
                        </el-col>
                        <el-col :sm="18">
                            <div class="embed-area"></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header feature small">
                    <div class="panel-title">常見問答</div>
                </div>
                <div class="panel-body">
                    <el-row :gutter="20">
                        <el-col :sm="6">
                            <div class="fqa-tabs">
                                <el-tabs v-model="activeTab" tabPosition="left">
                                    <el-tab-pane label="請款單" name="first"></el-tab-pane>
                                    <el-tab-pane label="發票" name="second"></el-tab-pane>
                                    <el-tab-pane label="專案" name="third"></el-tab-pane>
                                    <el-tab-pane label="審核流程" name="fourth"></el-tab-pane>
                                    <el-tab-pane label="分析" name="fourth"></el-tab-pane>
                                </el-tabs>
                            </div>
                        </el-col>
                        <el-col :sm="18">
                            <el-collapse v-model="activeNames" @change="handleChange" class="fqa">
                                <el-collapse-item title="納稅者權利保護官可以提供哪些協助呢?" name="1">
                                    <div>
                                        納稅者權利保護官應該提供納稅義務人以下協助：一、協助納稅者進行稅捐爭議之溝通與協調。二、受理納稅者之申訴或陳情，並提出改善建議。三、於納稅者依法尋求救濟時，提供必要之諮詢與協助。
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item title="境外電商業者銷售電子勞務予境內自然人者，其營業稅之納稅義務人為何？" name="4">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="納稅者權利保護法所稱納稅者為何？" name="2">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="納稅者權利保護法所稱納稅者為何？" name="3">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="綜合所得稅申報長期照顧特別扣除額之規定如何 ?" name="5">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="納稅者權利保護官可以提供哪些協助呢?" name="11">
                                    <div>
                                        納稅者權利保護官應該提供納稅義務人以下協助：一、協助納稅者進行稅捐爭議之溝通與協調。二、受理納稅者之申訴或陳情，並提出改善建議。三、於納稅者依法尋求救濟時，提供必要之諮詢與協助。
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item title="境外電商業者銷售電子勞務予境內自然人者，其營業稅之納稅義務人為何？" name="15">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="納稅者權利保護法所稱納稅者為何？" name="12">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="納稅者權利保護法所稱納稅者為何？" name="13">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                                <el-collapse-item title="綜合所得稅申報長期照顧特別扣除額之規定如何 ?" name="14">
                                    <div>外國之事業、機關、團體、組織，在中華民國境內無固定營業場所，銷售電子勞務予境內自然人者，該外國之事業、機關、團體、組織即為營業稅之納稅義務人。</div>
                                </el-collapse-item>
                            </el-collapse>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            activeTab: 'first',
            activeNames: '',
        };
    },
    methods: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.tutorial-page {
    .main-menu {
        font-size: 15pt;
        line-height: 200%;
        text-align: right;
        margin: 100px 0;
        padding-right: 40px;

        .item {
            color: #666;
            cursor: pointer;

            &:hover {
                color: $main-color;
                font-weight: bold;
            }
        }
    }

    .embed-area {
        width: 90%;
        height: 500px;
        margin: 50px 0;
        border: 1px solid #ccc;
        background-color: #ccc;
        border-radius: 10px;
    }

    .fqa-tabs {
        .el-tabs--left .el-tabs__header.is-left {
            float: right;
        }

        .el-tabs__item {
            font-size: 13pt;
        }
    }

    .fqa {
        .el-collapse-item__header {
            font-size: 12.5pt;
        }

        .el-collapse-item__content {
            font-size: 10.5pt;
            background-color: #f6f6f6;
            padding: 30px;
            border-radius: 13px;
        }
    }
}
</style>
